"use strict";
/*
 * Copyright (c) 2018 - Present, Vamstar Limited
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or
 * without modification, are not permitted.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.RequestForQuoteDraftStatus = void 0;
/**
 * @description draft status for rfq
 */
var RequestForQuoteDraftStatus;
(function (RequestForQuoteDraftStatus) {
    RequestForQuoteDraftStatus["QUOTE_REQUIREMENTS"] = "QUOTE_REQUIREMENTS";
    RequestForQuoteDraftStatus["QUOTE_DETAILS"] = "QUOTE_DETAILS";
    RequestForQuoteDraftStatus["REVIEW_AND_PUBLISHED"] = "REVIEW_AND_PUBLISHED";
})(RequestForQuoteDraftStatus = exports.RequestForQuoteDraftStatus || (exports.RequestForQuoteDraftStatus = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicmVxdWVzdC1mb3ItcXVvdGUtZHJhZnQtc3RhdHVzLmVudW0uanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvcmZxL3R5cGVzL3JlcXVlc3QtZm9yLXF1b3RlLWRyYWZ0LXN0YXR1cy5lbnVtLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7QUFBQTs7Ozs7O0dBTUc7OztBQUVIOztHQUVHO0FBQ0gsSUFBWSwwQkFJWDtBQUpELFdBQVksMEJBQTBCO0lBQ3BDLHVFQUF5QyxDQUFBO0lBQ3pDLDZEQUErQixDQUFBO0lBQy9CLDJFQUE2QyxDQUFBO0FBQy9DLENBQUMsRUFKVywwQkFBMEIsR0FBMUIsa0NBQTBCLEtBQTFCLGtDQUEwQixRQUlyQyJ9